import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { AccessType } from '../../types/access-type';
import { StageState } from '../../types/stage-state';

interface Props {
  id: string;
  title: string;
  createdAt: string;
  completedAt?: string;
  openedAt?: string;
  sequenceNumber: string;
  state: StageState;
  deadline: number;
  notif?: boolean;
  accesses: AccessType[];
}

const STATE_STYLE = {
  [StageState.BLOCKED]: 'border-zinc-400 text-zinc-400',
  [StageState.IN_PROGRESS]: 'border-primary-500 text-primary-500',
  [StageState.SUBMITTED]: 'border-primary',
  [StageState.ACCEPTED]: 'border-black text-black'
};

export default function StageCard({
  id,
  title,
  createdAt,
  completedAt,
  openedAt = '',
  sequenceNumber,
  deadline,
  state,
  notif = false,
  accesses
}: Props) {
  const remainingPercenageCalculated = useMemo(
    () => remainingPercent(openedAt, deadline),
    [openedAt, deadline]
  );

  return (
    <Link to={accesses.length !== 0 ? `stage/${id}` : '#'}>
      <div
        className={`stage-card relative py-3 px-2 border-2 bg-white ${STATE_STYLE[state]} border-gree rounded
        hover:shadow-md animate-fadeIn ${state !== StageState.BLOCKED && 'cursor-pointer'}`}
      >
        {accesses.length !== 0 && (
          <>
            {notif && (
              <span className="absolute rounded-full w-4 h-4 bg-red-700 opacity-75 -left-2 -top-2 animate-ping"></span>
            )}
            <span
              className={`absolute rounded-full w-3 h-3 border-4 border-red-600 ${
                accesses.indexOf(AccessType.WRITE) !== -1 ? 'bg-red-600' : 'bg-white'
              } -left-1.5 -top-1.5`}
            ></span>
          </>
        )}
        <div className="text-2xl text-center">{title}</div>

        <div className="stage-deadline h-6 w-ful flex flex-row-reverse space-x-5">
          {state === StageState.IN_PROGRESS && (
            <>
              <div className="text-right text-xs text-zinc-600">
                <div>مهلت</div>
                {addDays(new Date(openedAt), deadline).toLocaleDateString('fa-IR', {
                  dateStyle: 'short'
                })}
              </div>
              <div className="mx-2 self-center flex-grow bg-gray-200 rounded-full h-1 dark:bg-ye-700">
                <div
                  className={`bg-${percentColor(remainingPercenageCalculated)}  h-1 rounded-full`}
                  style={{ width: `${remainingPercenageCalculated}%` }}
                ></div>
              </div>
            </>
          )}
          {state === StageState.ACCEPTED && (
            <>
              <div className="text-right text-xs text-zinc-600">
                <div>تکمیل در</div>
                {new Date(completedAt ?? '').toLocaleDateString('fa-IR', {
                  dateStyle: 'short'
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}

function addDays(date: Date, days: number) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function remainingPercent(createdDate: string, deadline: number) {
  const passed = Date.now() - new Date(createdDate).valueOf();
  const all = deadline * 24 * 60 * 60 * 1000;
  return +Math.min(100, (100 * passed) / all).toPrecision(1);
}

function percentColor(percent: number) {
  const bucket = Math.floor(percent / 30);
  const colors = ['green-500', 'yellow-400', 'red-500', 'red-800'];
  return colors[bucket];
}
